/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CertificateSigning56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M38 40a6 6 0 110 12 6 6 0 010-12zM22 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M45 15a2 2 0 012 2v23a2 2 0 01-2 2H11a2 2 0 01-2-2V17a2 2 0 012-2h34z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M46 12c2.21 0 4 1.79 4 4v25c0 2.21-1.79 4-4 4H10c-2.21 0-4-1.79-4-4V16c0-2.21 1.79-4 4-4h36zm-1 2H11a3 3 0 00-3 3v23a3 3 0 003 3h34a3 3 0 003-3V17a3 3 0 00-3-3z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M46 10a6 6 0 015.996 5.775L52 16v25a6 6 0 01-5.775 5.996L46 47H10a6 6 0 01-5.996-5.775L4 41V16a6 6 0 015.775-5.996L10 10h36zm0 2H10a4 4 0 00-3.995 3.8L6 16v25a4 4 0 003.8 3.995L10 45h36a4 4 0 003.995-3.8L50 41V16c0-2.21-1.79-4-4-4zm-1 2a3 3 0 012.995 2.824L48 17v23a3 3 0 01-2.824 2.995L45 43H11a3 3 0 01-2.995-2.824L8 40V17a3 3 0 012.824-2.995L11 14h34zm0 1H11a2.001 2.001 0 00-1.995 1.85L9 17v23c0 1.054.816 1.918 1.85 1.995L11 42h34a2.001 2.001 0 001.995-1.85L47 40V17a2 2 0 00-2-2zM23.5 35a.5.5 0 010 1h-8a.5.5 0 010-1h8zm19 0a.5.5 0 010 1h-13a.5.5 0 010-1h13zm-19-3a.5.5 0 010 1h-8a.5.5 0 010-1h8zm0-3a.5.5 0 010 1h-8a.5.5 0 010-1h8zm-.5-8a1 1 0 010 2h-7a1 1 0 010-2h7z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M46.661 5.725l-.334.135c-.607.248-1.189.501-1.743.758l-.175.082-.436 2.628c-.289 1.735-2.491 2.259-3.542.913l-.095-.131-.486-.73-.255.199c-1.923 1.523-3.031 3.119-3.394 4.779l-.047.238c-.573 3.268-.934 6.96-1.08 11.072l-.03.992.341-.191c5.106-2.893 8.412-5.727 9.927-8.42l.126-.23c1.483-2.818 1.926-6.756 1.261-11.82l-.038-.274z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M48.24 3c1.285 6.75.941 12-1.032 15.75-1.883 3.579-6.282 7.157-13.198 10.736l-2.088 3.282a.5.5 0 01-.885-.456l.041-.08 1.925-3.025v-.101c.037-5.63.431-10.581 1.181-14.856.5-2.855 2.57-5.409 6.208-7.66L42 9l.607-3.646c1.64-.83 3.518-1.615 5.632-2.354zm-1.58 2.725l-.334.135c-.607.248-1.189.501-1.743.758l-.175.082-.436 2.628c-.289 1.735-2.491 2.259-3.542.913l-.095-.131-.486-.73-.255.199c-1.923 1.523-3.031 3.119-3.394 4.779l-.047.238c-.573 3.268-.934 6.96-1.08 11.072l-.01.298 3.014-4.734a.5.5 0 01.885.456l-.041.08-2.674 4.202c4.618-2.72 7.637-5.383 9.064-7.92l.126-.231c1.483-2.818 1.926-6.756 1.261-11.82l-.038-.274z"
            />
        </g>
    </AccessibleSVG>
);

export default CertificateSigning56;
